import {
  submitRatingRequest,
  submitRatingTagsRequest,
  submitRatingCommentRequest,
  submitAttemptToRateOnGoogleRequest,
  submitGreetRatingRequest,
  submitGreetRatingTagsRequest,
  submitGreetRatingCommentRequest,
} from './api';

export default {
  async submitRating(
    context,
    { uniqueOrderNumber, tipsQrCardHash, rating, paymentUuid, session }
  ) {
    const reviewId = context.getters.reviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      const response = await submitRatingRequest({
        session: sessionToUse,
        uniqueOrderNumber,
        tipsQrCardHash,
        reviewId,
        rating,
        paymentUuid,
      });
      context.commit('SET_REVIEW_ID', response.data.data.id);
    } catch (error) {
      console.error(error);
    }

    context.dispatch('sendAnalyticsEvent', {
      event: 'submit_rating',
      rating,
    });
  },
  async submitRatingTags(
    context,
    { uniqueOrderNumber, tipsQrCardHash, tags, paymentUuid, session }
  ) {
    const reviewId = context.getters.reviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      await submitRatingTagsRequest({
        session: sessionToUse,
        uniqueOrderNumber,
        tipsQrCardHash,
        reviewId,
        tags,
        paymentUuid,
      });
    } catch (error) {
      console.error(error);
    }

    context.dispatch('sendAnalyticsEvent', {
      event: 'submit_rating_tags',
      tags,
    });
  },
  async submitRatingComment(
    context,
    {
      uniqueOrderNumber,
      tipsQrCardHash,
      comment,
      email,
      phoneNumber,
      paymentUuid,
      session,
    }
  ) {
    const reviewId = context.getters.reviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      await submitRatingCommentRequest({
        session: sessionToUse,
        uniqueOrderNumber,
        tipsQrCardHash,
        reviewId,
        comment,
        email,
        phoneNumber,
        paymentUuid,
      });
    } catch (error) {
      console.error(error);
    }

    context.dispatch('sendAnalyticsEvent', {
      event: 'submit_rating_comment',
      comment,
    });
  },
  async submitAttemptToRateOnGoogle(
    context,
    { uniqueOrderNumber, tipsQrCardHash, session }
  ) {
    const reviewId = context.getters.reviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      await submitAttemptToRateOnGoogleRequest({
        session: sessionToUse,
        uniqueOrderNumber,
        tipsQrCardHash,
        reviewId,
      });
    } catch (error) {
      console.error(error);
    }

    context.dispatch('sendAnalyticsEvent', {
      event: 'submit_attempt_to_rate_on_google',
    });
  },
  async submitGreetRating(
    context,
    { rating, uniqueOrderNumber, tipsQrCardHash, session }
  ) {
    const reviewId = context.getters.greetReviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      const response = await submitGreetRatingRequest({
        session: sessionToUse,
        reviewId,
        uniqueOrderNumber,
        tipsQrCardHash,
        rating,
      });
      context.commit('SET_GREET_REVIEW_ID', response.data.data.uuid);
    } catch (error) {
      console.error(error);
    }
  },
  async submitGreetRatingTags(context, { tags, session }) {
    const reviewId = context.getters.greetReviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      await submitGreetRatingTagsRequest({
        session: sessionToUse,
        reviewId,
        tags,
      });
    } catch (error) {
      console.error(error);
    }
  },
  async submitGreetRatingComment(context, { comment, session }) {
    const reviewId = context.getters.greetReviewId;
    const sessionToUse = session || context.rootState.session;
    try {
      await submitGreetRatingCommentRequest({
        session: sessionToUse,
        reviewId,
        comment,
      });
    } catch (error) {
      console.error(error);
    }
  },
};
